import {ReasonDescriptionInfo} from './reason-description-info';

export abstract class ReasonDescriptionInfoComponent {
  abstract info: ReasonDescriptionInfo;
}
